import { useExplorationState, useFilteredVolumes } from '../../context/ExplorationContext';
import type { ExplorationVolume } from '../../types/exploration';
import SidebarBreakdownCard from './SidebarBreakdownCard';
import SidebarGroupBarsCard from './SidebarGroupBarsCard';
import SidebarStorageCard from './SidebarStorageCard';
import type { InstanceDetailsProps } from './instanceDetails.types';

function resolveInstanceVolumes(
  instanceId: string,
  selectionVols: ExplorationVolume[],
  filtered: ExplorationVolume[]
): ExplorationVolume[] {
  return selectionVols.length > 0
    ? selectionVols
    : filtered.filter((v) => v.instanceId === instanceId);
}

export default function InstanceDetails({ instanceId, vols: selectionVols }: InstanceDetailsProps) {
  const state = useExplorationState();
  const filtered = useFilteredVolumes();

  const instanceVols = resolveInstanceVolumes(instanceId, selectionVols, filtered);
  const isActivation = state.view === 'activation';

  return (
    <div>
      <SidebarStorageCard scoped={instanceVols} />
      {isActivation ? (
        <SidebarBreakdownCard variant="activation" volumes={instanceVols} />
      ) : (
        <SidebarBreakdownCard variant="support" volumes={instanceVols} />
      )}
      <SidebarGroupBarsCard volumes={instanceVols} />
    </div>
  );
}
